/**
 * @file 我加入的班级
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

/**
 * 加入的班级信息
 */
export interface IJoinClassInfo extends ISelectableClassInfo {
    join_ts?: number;
    teacher_list?: ITeacherBaseInfo[];
    stat: {
        joined_num: number;
        not_joined_num: number;
    };
}

export interface IInput {
    page: number; // int，必填，分页页码
    size: number; // int，必填，每页展示数据量
    keyword: string; // string，非必填，班级名称检索关键字
}

export const getJoinList = (data: IInput): Promise<IList<IJoinClassInfo>> => {
    return fetchData(Api.CLASS_JOIN_LIST, data).then((res: IListResponse<IJoinClassInfo>) => {
        return res.data as IList<IJoinClassInfo>;
    });
};
